const downloadBlob = (blob: Blob, fileName: string) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");

  a.style.display = "none";
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);

  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

export const downloadDataAsFile = (
  data: File | Blob,
  fileName: string,
  type: string
) => {
  const blob = new Blob([data], { type });

  downloadBlob(blob, fileName);
};

export const downloadDataAsCSVFile = (data: File, fileName: string) =>
  downloadDataAsFile(data, fileName, "text/csv");

export const downloadFromUrl = async (url, fileName, format) =>
  fetch(url)
    .then((res) => res.blob())
    .then((blob) => downloadBlob(blob, `${fileName}.${format}`));
